import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatorService } from '../core/translator/translator.service';
import { MenuService } from '../core/menu/menu.service';
import { SharedModule } from '../shared/shared.module';
import { PagesModule } from './pages/pages.module';
import { routes } from './routes';
import { ProductService } from '../core/services/product.service';
import { AngularMultiSelectModule } from '@khajegan/angular2-multiselect-dropdown';
import { OwnerService } from '../core/services/owner.service';
@NgModule({
    imports: [
        SharedModule,
        RouterModule.forRoot(routes, { useHash: true }),
        PagesModule,
        AngularMultiSelectModule
    ],
    declarations: [],
    exports: [
        RouterModule
    ],
    providers: [ProductService, OwnerService]
})

export class RoutesModule {
    constructor(public menuService: MenuService, tr: TranslatorService) {
    }
}
